"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorType = void 0;
var OperatorType;
(function (OperatorType) {
    OperatorType["MATCHES"] = "MATCHES";
    OperatorType["GTE"] = "GTE";
    OperatorType["GT"] = "GT";
    OperatorType["LTE"] = "LTE";
    OperatorType["LT"] = "LT";
    OperatorType["ONE_OF"] = "ONE_OF";
    OperatorType["NOT_ONE_OF"] = "NOT_ONE_OF";
})(OperatorType = exports.OperatorType || (exports.OperatorType = {}));
//# sourceMappingURL=rule-dto.js.map